import { render, staticRenderFns } from "./main.vue?vue&type=template&id=3bd122fa&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd122fa')) {
      api.createRecord('3bd122fa', component.options)
    } else {
      api.reload('3bd122fa', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=3bd122fa&", function () {
      api.rerender('3bd122fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/components/webViewImage/src/main.vue"
export default component.exports